export interface HotItem {
  id: number;
  title: string;
  tag: string;
  heat: string;
  bar: number;
  trend: 'up' | 'down' | 'new' | 'flat';
  desc: string;
}

export const hotItems: HotItem[] = [
  {
    id: 1,
    title: '口碑悬疑剧大结局实时讨论刷新峰值',
    tag: '影视',
    heat: '1286.4万',
    bar: 100,
    trend: 'up',
    desc: '结局伏笔集中回收，社区复盘帖与解读向内容同步爆发。',
  },
  {
    id: 2,
    title: '实力派阵容同台舞台企划官宣',
    tag: '娱乐',
    heat: '1023.7万',
    bar: 94,
    trend: 'new',
    desc: '首波预告片花被逐帧解读，舞台主题猜测刷屏多平台。',
  },
  {
    id: 3,
    title: '暑期档黑马大片实时想看数走高',
    tag: '影视',
    heat: '968.2万',
    bar: 88,
    trend: 'up',
    desc: '定档信息叠加预告物料，预售与排片预期持续上调。',
  },
  {
    id: 4,
    title: '户外真人秀路透嘉宾阵容疑似曝光',
    tag: '综艺',
    heat: '847.5万',
    bar: 79,
    trend: 'up',
    desc: '转场路透与任务主题猜测引发二轮讨论。',
  },
  {
    id: 5,
    title: '音乐节名单流出又被删，全网接力整理',
    tag: '娱乐',
    heat: '792.3万',
    bar: 72,
    trend: 'down',
    desc: '被删名单引发线索接力，开票时间成下一焦点。',
  },
  {
    id: 6,
    title: '多城文旅消费季市集玩法出圈',
    tag: '社会',
    heat: '718.6万',
    bar: 66,
    trend: 'up',
    desc: '非遗市集与城市漫游结合，打卡热与客流同步升温。',
  },
  {
    id: 7,
    title: '「瓜田里的猹」看瓜文学二创冲顶',
    tag: '热梗',
    heat: '653.9万',
    bar: 60,
    trend: 'new',
    desc: '从表情包到段子短视频，看瓜话语体系成套出现。',
  },
  {
    id: 8,
    title: '品牌盛典红毯造型实时盘点开战',
    tag: '娱乐',
    heat: '578.4万',
    bar: 52,
    trend: 'flat',
    desc: '网友自发投票盘点最佳造型，评论实时刷新。',
  },
  {
    id: 9,
    title: '唱作类音乐综艺新一季剪影官宣',
    tag: '综艺',
    heat: '501.2万',
    bar: 45,
    trend: 'down',
    desc: '官方彩蛋埋线，导师与飞行阵容身份推理火热。',
  },
  {
    id: 10,
    title: '夏日音乐现场连开三城攻略汇总',
    tag: '娱乐',
    heat: '436.8万',
    bar: 38,
    trend: 'flat',
    desc: '跨城追现场乐迷整理票务与转场实时信息。',
  },
];